import React from 'react';

import image1 from '../../assets/images/110725-LOGO-MILI.png';
import image2 from '../../assets/images/110725-LOGO-PRODUCTO-NUTRET.png';
import image3 from '../../assets/images/110725-LOGO-ZAKS.png';
import './loader.css';

function Loader() {
  return (
    <div className="loader-container">
      <img src={image1} alt="Loader 1" className="loader-image delay-0" />
      <img src={image2} alt="Loader 2" className="loader-image delay-1" />
      <img src={image3} alt="Loader 3" className="loader-image delay-2" />
    </div>
  );
};

export default Loader;